console.time("AppReady");
import {
	EventDispatcher,
	DomUtil
} from "cartovista";
import CartovistaExtend from "cartovistaExtend/CartovistaExtend";
import ServiceAreas from "cartovistaExtend/panels/na/ServiceAreas";
import {loadData, createLayers, createThemeSetsElements, initZoomLayeringLayers} from "./ServerDataHandlers";
import { Modal } from 'bootstrap';
import '../styles/mfa.css';

class App extends EventDispatcher {
	constructor(cartovista) {
		super();
		this.cartovista = cartovista;
        new ServiceAreas();
		window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
		window.cartovista.addOneTimeEventListener("ServerDataInitialized", this._onServerLayersLoaded, this);
		loadData();
		this._onThemeSetAppliedDataLoaded = false;
    }

    _onCartoVistaMapLoaded() {
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        createLayers();
        var reorderConfig = [
            {LAYER_ID: "Installations", INDEX: 20},
            {LAYER_ID: "OCF", INDEX: 20},
            {LAYER_ID: "SERVICE_AREAS", INDEX: 29}
        ];
        _.forEach(reorderConfig, function(config){
            this._reorderLayer(config);
        }.bind(this));
        createThemeSetsElements();
        initZoomLayeringLayers();
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onThemeSetChanged, this);
    }

    _reorderLayer(config) {
        var map = window.cartovista.externalInterface.map;
        var layer = map.getLayer(config.LAYER_ID);
        map.removeLayer(layer);
        map.addLayerAt(layer, config.INDEX);
    }

    _onServerLayersLoaded() {
        console.timeEnd("AppReady");
        $("#preloader").remove();
		new Modal('#IntroModal').show();
        if(window.location.search.substring(1) != "dev") {
            this._map.activeThemeSet = this._map.getThemeSet(window.location.search.substring(1));
        }
    }

    _onThemeSetChanged() {
        if (this._map.activeThemeSet && this._map.activeThemeSet.id.indexOf("SZ_") == -1) {
            this._zoomOnThemeSetRegion(this._map.activeThemeSet);
        }
    }

    _zoomOnThemeSetRegion(activeThemeSet) {
        var layerSetting = _.find(activeThemeSet.themeSetMapSettings.themeSetLayerSettings, function(layerSetting) {
            return layerSetting.visible && layerSetting.layer.layerType == "POLYGON" && layerSetting.layer.id != "GEOCODER_CP" && layerSetting.layer.id != "SERVICE_AREAS";
        });
        if (typeof layerSetting != "undefined") {
            layerSetting.layer.getFeatures(null, function(result) {
                this._mapController.zoomOnFeatures(result.features, null, null, false);
            }, this, true);
        }
    }

}

$().ready(function() {
	new App(new CartovistaExtend());
});
